import api from './api';

const companyService = {
  // List companies (scope-aware)
  getCompanies: async () => {
    const response = await api.get('/company');
    return response.data.data;
  },
  // Get company info
  getCompany: async (companyId) => {
    const response = await api.get(`/company/${companyId}`);
    return response.data.data;
  },
  
  // Update company info
  updateCompany: async (companyId, data) => {
    const response = await api.patch(`/company/${companyId}`, data);
    return response.data.data;
  },
  
  // Get company users
  getUsers: async (params = {}) => {
    const { search, userType, status, page, limit } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (userType) queryParams.append('userType', userType);
    if (status) queryParams.append('status', status);
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    
    const response = await api.get(`/company/users?${queryParams}`);
    return response.data.data;
  },
  
  // Get user details
  getUserById: async (userId) => {
    const response = await api.get(`/company/users/${userId}`);
    return response.data.data.user;
  },
  
  // Update user
  updateUser: async (userId, data) => {
    const response = await api.patch(`/company/users/${userId}`, data);
    return response.data.data.user;
  },
  
  // Delete user
  deleteUser: async (userId) => {
    const response = await api.delete(`/company/users/${userId}`);
    return response.data;
  },
  
  // Get stats (scope-aware: companyId optional for system admin)
  getStats: async (companyId = null) => {
    const queryParams = new URLSearchParams();
    if (companyId) queryParams.append('companyId', companyId);
    
    const url = companyId 
      ? `/company/users/stats?${queryParams}`
      : '/company/users/stats';
    
    const response = await api.get(url);
    return response.data.data;
  }
};

export default companyService;

